const doc = [({"da":({"js":({"admin":({"economy":({"employees":({"employees":"Medarbejdere"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;